<template>
	<div class="col-xs-12 footer-document-preview">
		<div class="table-responsive">
			<table class="table">
				<tfoot>
					<tr>
						<td v-if="!!company && company.logo" rowspan="4" width="140px" style="border-top:1px solid #f2f2f2 !important;">
							<img :src="company.logo" class="img-responsive" />
						</td>
					</tr>
					<tr>
						<td colspan="2" width="300px" style="border-top: 1px solid #f2f2f2 !important;"><b>{{this.company ? this.company.name : ""}}</b></td>
					</tr>
					<tr>
						<td width="300px">{{this.company ? this.company.address : ""}}</td>
						<td><a v-bind:href="'tel:/' + (this.company ? this.company.phone : '')">{{this.company ? this.company.phone : ""}}</a></td>
					</tr>
					<tr>
						<td width="300px"><a v-bind:href="'https://' + (this.company ? this.company.website : '')">{{this.company ? this.company.website : ""}}</a></td>
						<td><a v-bind:href="'mailto:/' + (this.company ? this.company.email : '')">{{this.company ? this.company.email : ""}}</a></td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		setting: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			company: this.company,
			styleObject: "",
			isLoading: false
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			if (!this.setting) {
				const settingResp = await axios.get(`/settings`);
				this.company = settingResp.data.data.company;
			} else this.company = this.setting;

			this.styleObject = {
				background: `#FFF scroll 0% 0%`,
				backgroundRepeat: 'no-repeat !important',
				backgroundImage: 'url(' + this.company.logo ? this.company.logo : null + ') !important',
				backgroundSize: 'contain',
			};

		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}

		this.isLoading = false;
	},
}
</script>
